module.exports = __webpack_public_path__ + "img/setting_btn.f57cf7c3.png";